import React, { useState } from "react";
import { TheContent, TheSidebar, TheAside, TheHeader } from "./index";
import Store from "../store";

const TheLayout = () => {
  const darkMode = false;
  const classes = `c-app c-default-layout ${darkMode ? "c-dark-theme" : ""}`;
  const [showSidebar, setShowSidebar] = useState(true);
  const toggleShow = (val: boolean) => {
    setShowSidebar(val);
  };

  return (
    <div className={classes}>
      <div className="banner"></div>
      <TheSidebar showSidebar={showSidebar} toggleSidebarMobile={toggleShow} />
      <div className="c-wrapper">
        <TheHeader toggleSidebarMobile={toggleShow} />
        <div className="c-body">
          <TheContent />
        </div>
      </div>
    </div>
  );
};

export default TheLayout;
